module.exports = __webpack_public_path__ + "img/icon-arrow-next.fd6460be.svg";